import { IDataEndPoint, IEntityEndPoints, IFieldOptions, IFormOptions, IGridOptions, IColumnOptions, IEntityOptions } from '@framework/interfaces/IEntity';
import * as app from '@framework/app';
import * as models from '@common/domain/models/PartyAddressTypeDTO';
import { IApiServiceCommand } from '@services/api/api.service';
export class PartyAddressTypeEndPoints implements IEntityEndPoints {
	list?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType"}, method: "GET" };
	get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType/" + serviceCommand.context.entityId}, method: "GET" };
	update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType/update/" + serviceCommand.context.entityId}, method: "POST" };
	search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType/lazy/"}, method: "POST" };
	pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType/lazyCount/"}, method: "POST" };
	insert?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType/create"}, method: "POST" };
	delete?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/partyAddressType/delete/"+ serviceCommand.context.entityId}, method: "POST" };
}

export class PartyAddressTypeFormFields extends Array<IFieldOptions> {
	public id: IFieldOptions = { field: "id" };
	public status: IFieldOptions = { field: "status" };
	public datestamp: IFieldOptions = { field: "datestamp" };
	public changedById: IFieldOptions = { field: "changedById" };
	public name: IFieldOptions = { field: "name" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.name);
	}
}

export class PartyAddressTypeForm implements IFormOptions {
	protected partyAddressTypeFormName: string = "partyAddressTypeForm";
	protected partyAddressTypeFormModel: models.PartyAddressTypeDTO = new models.PartyAddressTypeDTO();
	protected partyAddressTypeFormEndPoints: PartyAddressTypeEndPoints = new PartyAddressTypeEndPoints();
	protected partyAddressTypeFormFields: PartyAddressTypeFormFields = new PartyAddressTypeFormFields();
	public get name(): string { return this.partyAddressTypeFormName };
	public get model(): models.PartyAddressTypeDTO { return this.partyAddressTypeFormModel };
	public get endPoints(): IEntityEndPoints { return this.partyAddressTypeFormEndPoints };
       public set endPoints(partyAddressTypeEndPoints: IEntityEndPoints) {
		this.partyAddressTypeFormEndPoints = partyAddressTypeEndPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.get };
	public get fields(): PartyAddressTypeFormFields { return this.partyAddressTypeFormFields };
}

export class PartyAddressTypeListColumns extends Array<IColumnOptions> {
	public id: IColumnOptions = { field: "id" };
	public status: IColumnOptions = { field: "status" };
	public datestamp: IColumnOptions = { field: "datestamp", template: function (fldValue) { return (new Date(fldValue)["shortDate"]()).toString(); } };
	public changedById: IColumnOptions = { field: "changedById" };
	public name: IColumnOptions = { field: "name" };
	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.name);
	}
}

export class PartyAddressTypeList implements IGridOptions {
	protected partyAddressTypeListName: string = "partyAddressTypeList";
	protected partyAddressTypeListModel: models.PartyAddressTypeDTO = new models.PartyAddressTypeDTO();
	protected partyAddressTypeListEndPoints: PartyAddressTypeEndPoints = new PartyAddressTypeEndPoints();
	protected partyAddressTypeListColumns: PartyAddressTypeListColumns = new PartyAddressTypeListColumns();
	public partyAddressTypeForm: PartyAddressTypeForm = new PartyAddressTypeForm();
	public get name(): string { return this.partyAddressTypeListName };
	public get model(): models.PartyAddressTypeDTO { return this.partyAddressTypeListModel };
	public get endPoints(): IEntityEndPoints { return this.partyAddressTypeListEndPoints };
	public set endPoints(partyAddressTypeEndPoints: IEntityEndPoints) {
		this.partyAddressTypeListEndPoints = partyAddressTypeEndPoints;
		this.partyAddressTypeForm.endPoints = this.endPoints;
	};
	public get dataEndPoint(): IDataEndPoint { return this.endPoints.list };
	public get columns(): PartyAddressTypeListColumns { return this.partyAddressTypeListColumns };
}

export class PartyAddressTypeEntity implements IEntityOptions {
	protected partyAddressTypeEntityName: string = "partyAddressTypeEntity";
	protected partyAddressTypeEntityModel: models.PartyAddressTypeDTO = new models.PartyAddressTypeDTO();
	protected partyAddressTypeEntityEndPoints: PartyAddressTypeEndPoints = new PartyAddressTypeEndPoints();
	protected partyAddressTypeEntityList: PartyAddressTypeList = new PartyAddressTypeList();
	public get name(): string { return this.partyAddressTypeEntityName };
	public get model(): models.PartyAddressTypeDTO { return this.partyAddressTypeEntityModel };
	public get endPoints(): IEntityEndPoints { return this.partyAddressTypeEntityEndPoints };
	public set endPoints(partyAddressTypeEndPoints: IEntityEndPoints) {
		this.partyAddressTypeEntityEndPoints = partyAddressTypeEndPoints;
		this.grid.endPoints = this.endPoints;
	};
	public get grid(): PartyAddressTypeList { return this.partyAddressTypeEntityList };
	public get form(): PartyAddressTypeForm { return this.grid.partyAddressTypeForm };
	constructor(name?: string) {
		if (name) this.partyAddressTypeEntityName = name;
		this.endPoints = this.partyAddressTypeEntityEndPoints;
	}
};
//export class PartyAddressTypeGeneratedForm extends MfGeneratedFormComponent {
 // protected detailPageComponentForm: PartyAddressTypeForm = new PartyAddressTypeForm();
//};

//export class PartyAddressTypeListPageComponent extends ListPageComponent {
  //protected listPageComponentList: PartyAddressTypeList = new  PartyAddressTypeList();
  //protected showFilterColOnTable: boolean = true;
//};

//export class PartyAddressTypeBlade extends MfBladeComponent {
  //protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PartyAddressTypeGeneratedForm}];
//};

//export class PartyAddressTypeListBlade extends MfBladeComponent {
 // protected detailComponents: Array<IDetailComponent> = [ { index: 0, displayName: "Properties", component: PartyAddressTypeListPageComponent, isMenuHidden: true }];
//};

